import { __decorate, __extends } from "tslib";
import { Injectable } from '@angular/core';
import { AwesomeCordovaNativePlugin, cordova } from '@awesome-cordova-plugins/core';
import * as i0 from "@angular/core";
var Clipboard = /** @class */ (function (_super) {
    __extends(Clipboard, _super);
    function Clipboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Clipboard.prototype.copy = function (text) { return cordova(this, "copy", {}, arguments); };
    Clipboard.prototype.paste = function () { return cordova(this, "paste", {}, arguments); };
    Clipboard.prototype.clear = function () { return cordova(this, "clear", {}, arguments); };
    Clipboard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: Clipboard, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
    Clipboard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: Clipboard });
    Clipboard.pluginName = "Clipboard";
    Clipboard.plugin = "cordova-clipboard";
    Clipboard.pluginRef = "cordova.plugins.clipboard";
    Clipboard.repo = "https://github.com/ihadeed/cordova-clipboard";
    Clipboard.platforms = ["Android", "iOS", "Windows Phone 8"];
    Clipboard = __decorate([], Clipboard);
    return Clipboard;
}(AwesomeCordovaNativePlugin));
export { Clipboard };
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: Clipboard, decorators: [{
            type: Injectable
        }], propDecorators: { copy: [], paste: [], clear: [] } });
